import { ReactNode } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { Theme } from "@mui/material/styles";

import MDBox from "components/MDBox";

import PageLayout from "parts/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "components/Footer";

// Declaring props types for CoverLayout
interface Props {
  coverHeight?: string;
  image: string;
  children: ReactNode;
}

function CoverLayout({ coverHeight = "35vh", image, children }: Props): JSX.Element {
  return (
    <PageLayout>
      <MDBox
        width="calc(100% - 2rem)"
        minHeight={coverHeight}
        borderRadius="xl"
        mx={2}
        my={2}
        pt={6}
        pb={28}
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }: Theme) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.4),
              rgba(gradients.dark.state, 0.4)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      
      <MDBox 
        mt={{ xs: -20, lg: -18 }} 
        px={1} 
        width="calc(100% - 2rem)" 
        mx="auto"
        mb={2} 
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>

      <MDBox 
        sx={{ 
          width: '100%',
          '& > *': {
            position: 'relative !important',
            bottom: 'auto !important'
          }
        }}
      >
        <Footer />
      </MDBox>
    </PageLayout>
  );
}

export default CoverLayout;
